// Parse a date-only YYYY-MM-DD string as local midnight. Bare ISO dates are
// otherwise treated as UTC by the Date constructor, which shifts the calendar
// day west of UTC when formatted with local getters.
function parseDateYMD(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        return new Date(y, m - 1, d);
    }
    return new Date(value);
}

function DatetimeToDate(datetime) {
    // console.log(datetime);
    // console.log(new Date(datetime));
    return parseDateYMD(datetime);
}

function TimestampToDate(timestamp) {
    return new Date(timestamp * 1000);
}

function DateToTimestamp(date) {
    return Math.floor(date.getTime() / 1000);
}

function NowToTimestamp() {
    return DateToTimestamp(new Date());
}

function DateToFormat(date, format) {
    // Full template is YYYY-MM-DD HH:mm:ss AMPM

    const monthsF = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const daysF = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const months3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days3 = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const min = date.getMinutes();
    const sec = date.getSeconds();

    const monthNameF = monthsF[date.getMonth()];
    const dayNameF = daysF[date.getDay()];

    const monthName3 = months3[date.getMonth()];
    const dayName3 = days3[date.getDay()];

    //const padZero = (num) => (num < 10 ? '0' + num : num);
    
    if (!format) {
        format = 'us';
    }

    if (format === 'us') {
        format = 'MM/DD/YYYY';
    }

    const replacements = {
        'YYYY': year,
        'MM': padZero(month),
        'DD': padZero(day),
        'HH': padZero(hour),
        'mm': padZero(min),
        'ss': padZero(sec),
        'MF': monthNameF,
        'DF': dayNameF,
        'M3': monthName3,
        'D3': dayName3,
        'AMPM': (hour > 12 ? hour - 12 : hour === 0 ? 12 : hour) + ':' + padZero(min) + ' ' + (hour >= 12 ? 'PM' : 'AM'),
    };

    return format.replace(/YYYY|MM|DD|HH|mm|ss|M3|D3|MF|DF|AMPM/g, (match) => replacements[match]);
}

function padZero (num) { 
    return num < 10 ? '0' + num : num;
}

function calculateAge(birthDate) {
    //const birthDate = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
  
    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
  
    return age;
}

// Inclusive calendar months in program: alignment month = 1, next month = 2, etc.
// Ignores day-of-month (Jan 15 → Aug 7 is month 8, same as Jan 1 → Aug 7).
function programMonths(date) {
    const today = new Date();
    const months =
        (today.getFullYear() - date.getFullYear()) * 12 +
        (today.getMonth() - date.getMonth()) +
        1;
    return months < 1 ? 1 : months;
}

function FirstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
}

function LastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
}

function InRange(date, start, end) {
    return date >= start && date <= end;
}

// Enhanced version with timezone handling options
function InRangeUTC(date, start, end) {
    // Convert all dates to UTC for comparison
    const dateUTC = new Date(date.getTime());
    const startUTC = new Date(start.getTime());
    const endUTC = new Date(end.getTime());
    
    return dateUTC >= startUTC && dateUTC <= endUTC;
}

function InRangeLocalDate(date, start, end) {
    // Compare only the date parts, ignoring time and timezone
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const startOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const endOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    
    return dateOnly >= startOnly && dateOnly <= endOnly;
}

function DateUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

function NanosecondsToHHMM(nanoseconds) {
    // Convert nanoseconds to milliseconds
    const milliseconds = nanoseconds / 1000000;
    
    // Convert to hours and minutes
    const totalMinutes = Math.floor(milliseconds / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    // Format as HH:mm
    return `${padZero(hours)}:${padZero(minutes)}`;
}

// Local calendar date as YYYY-MM-DD (no time, no timezone). Use this when
// serializing date pickers so axios/JSON doesn't convert a Date to ISO UTC.
function formatDateYMD(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export { DatetimeToDate, TimestampToDate, DateToTimestamp, DateToFormat, NowToTimestamp, calculateAge, programMonths, FirstDayOfMonth, LastDayOfMonth, InRange, InRangeUTC, InRangeLocalDate, DateUTC, NanosecondsToHHMM, formatDateYMD, parseDateYMD };